var _circle, _g, _g2, _circle2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArgusSpinner(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 200 200",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    stroke: "currentColor",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Argus - Loading Spinner (Motion State 02 \xB7 Inference)") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 92,
    strokeWidth: 5
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 3.5,
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    from: "0 100 100",
    to: "360 100 100",
    dur: "6s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 119.2 28.5 A 74 74 0 0 1 171.5 80.8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 171.5 119.2 A 74 74 0 0 1 119.2 171.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 80.8 171.5 A 74 74 0 0 1 28.5 119.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 28.5 80.8 A 74 74 0 0 1 80.8 28.5"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 3,
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("animateTransform", {
    attributeName: "transform",
    type: "rotate",
    from: "0 100 100",
    to: "-360 100 100",
    dur: "4s",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 75 56.7 A 50 50 0 0 1 125 56.7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 143.3 75 A 50 50 0 0 1 143.3 125"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 125 143.3 A 50 50 0 0 1 75 143.3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 56.7 125 A 50 50 0 0 1 56.7 75"
  }))), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 100,
    cy: 100,
    r: 13,
    fill: "currentColor",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    values: "13;15.5;13",
    dur: "2s",
    repeatCount: "indefinite",
    calcMode: "spline",
    keyTimes: "0; 0.5; 1",
    keySplines: "0.42 0 0.58 1; 0.42 0 0.58 1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArgusSpinner);
export default __webpack_public_path__ + "static/media/argus-spinner.cf77cc8e9ef36de26bb0115fc01f30ee.svg";
export { ForwardRef as ReactComponent };